import { Injectable } from '@angular/core';
import { Observable, from, BehaviorSubject, Subject } from 'rxjs';
import { SharedService } from '../sheared/sharedService.service';
import { map } from 'rxjs/operators';
import { AngularFireDatabase } from '@angular/fire/database';
import { authenticationService, Clients } from '../Authentication/authentication.service';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { AssureurService } from '../Assureur/assureur.service';



@Injectable({
  providedIn: 'root'
})
export class HistoriqueService implements Resolve<Observable<any[]>> {

  private _quittances = new BehaviorSubject<any[]>([]); // quittance[]=any
   Lesquittances = new BehaviorSubject<any[]>([]); // quittance[]=any
   Lesquittances0 = new BehaviorSubject<any[]>([]); // quittance[]=any
  loading: HTMLIonLoadingElement
  //private dataStore: { quittances: any[] } = { quittances: [] };
  readonly quittances = this._quittances.asObservable();
private lstAss:any[]

  constructor(private sharedService: SharedService,
    private db: AngularFireDatabase,
    private loadingController: LoadingController,
    private assur:AssureurService,
    private auth:authenticationService) {
      this.assur.ListAssreurs.subscribe(
        res =>{
              this.lstAss=res
        }
      )

  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    var profil = this.auth.profile
  await this.historiquePolices(profil).then(
    (res) => {
      this._quittances.next(res)
      //this.dataStore.quittances = res
      //this._quittances.next(Object.assign({}, this.dataStore).quittances)
      this.loading.dismiss();
      //return Object.assign({}, this.dataStore).quittances
    }
  )


    

    return this.quittances
  }


  async historiquePolices(profil: Clients) {
    this.loading = await this.loadingController.create({
      message: 'Chargement...',
      duration: 30000,
      mode:"ios",
      spinner: 'bubbles'
    });

    await this.loading.present();

    var handelResult = [];
    const tree = this.db.database.ref()
    const ref2 = tree.child(`Quittances/`)
    await ref2.orderByChild('idKey').equalTo(profil.uid)
      //.orderByChild('nomAssureur').equalTo(profil.nomAssureur)
      .on('child_added', snapshot => {
        const $key = snapshot.key; // clé hashée de quittance
        tree.child(`Quittances/${$key}`)
          .on('value', snap => {
            // && snap.val().solde && snap.val().flag
            // if (profil.CodeAssu==snap.val().CodeAssur && snap.val().flag) {   }
            let lstPaie = [];
            const {listPaie,montant_due,etatdoc,CodeMvt,date_paiement,
              dateInsert0,CodeAssur,namePar,idKey,idkeyPar,icon,solde,type,
              NumPolice,numClient,dateEffet,dateExpi}=snap.val()

            for (const key in listPaie) {
              if (
                Object.prototype.hasOwnProperty.call(
                  listPaie,
                  key
                )
              ) {
                const element =listPaie[key];
                if (element.solde) {
                lstPaie.push({
                  modePayement: element.modePayement,
                  montantPayement: (typeof(element.mtnLivraison*1)===typeof(2000))? element.montantPayement*1-2000:element.montantPayement,
                  mtnLivraison: element.mtnLivraison,
                });
              }
              }
            }
            try {
               let mnt=montant_due - (lstPaie.reduce((acc, curr) => Number(acc) + Number(curr.montantPayement), 0 ))

              const res=this.Etatpuce(etatdoc)
              handelResult.push({
                $key:$key,
                CodeMvt:CodeMvt,
                CodeAssur:CodeAssur,
                numClient:numClient,
                police:NumPolice,
                NumPolice:NumPolice + " [ " + this.lstAss.find(e => e.CodeAssu==CodeAssur).NomAssu + " ]",
                dateEffet:dateEffet, //this.sharedService.ConvertDMYorYMD(dateEffet, "d/m/y"),
                dateExpi:dateExpi ,//this.sharedService.ConvertDMYorYMD(dateExpi, "d/m/y"),
                etatdoc:res[0],
                expression:res[1], 
                nbPaie:lstPaie.length,
                montant_restant:mnt,
                montantVerse: lstPaie.reduce((acc, curr) => Number(acc) + Number(curr.montantPayement),0),
                icon:icon,
                solde: mnt===0? true:false,// solde,
                type:type,
                montant_due:montant_due,
                datePaie0: dateInsert0,
                datePaie:this.sharedService.ConvertDMYorYMD(date_paiement),
                partage:idkeyPar,
                idproprio:idKey,
                namePar:namePar
              })     
            } catch (error) {
              
            }
               
        })
      });

    return await this.PrepareData(handelResult)

  }


 
  async histPolicesPartage() {
   
    var handelResult = [];
    const tree = this.db.database.ref()
    const ref2 = tree.child('Quittances')

    await ref2.orderByChild('idkeyPar').equalTo( this.auth.profile.uid)
    .on('child_added', snapshot => {
      const $key = snapshot.key; // clé hashée de quittance
      tree.child(`Quittances/${$key}`)
        .once('value', snap => {
          let lstPaie = [];
          for (const key in snap.val().listPaie) {
            if (
              Object.prototype.hasOwnProperty.call(
                snap.val().listPaie,
                key
              )
            ) {
              const element = snap.val().listPaie[key];
              if (element.solde) {
              lstPaie.push({
                modePayement: element.modePayement,
                montantPayement:(typeof(element.mtnLivraison*1)===typeof(2000))? element.montantPayement*1-2000:element.montantPayement,
                mtnLivraison: element.mtnLivraison,
              });
            }
            }
          }
          try {
            const res=this.Etatpuce(snap.val().etatdoc)
            handelResult.push({
              $key:$key,
              CodeMvt:snap.val().CodeMvt,
              CodeAssur:snap.val().CodeAssur,
              numClient:snap.val().numClient,
              police:snap.val().NumPolice,
              NumPolice:snap.val().NumPolice + " [ " + this.lstAss.find(e => e.CodeAssu==snap.val().CodeAssur).NomAssu + " ]",
              dateEffet:snap.val().dateEffet, //this.sharedService.ConvertDMYorYMD(snap.val().dateEffet, "d/m/y"),
              dateExpi:snap.val().dateExpi ,//this.sharedService.ConvertDMYorYMD(snap.val().dateExpi, "d/m/y"),
              etatdoc:res[0],
              expression:res[1], 
              nbPaie:lstPaie.length,
              montant_restant:snap.val().montant_due - (lstPaie.reduce((acc, curr) => Number(acc) + Number(curr.montantPayement), 0 )),
              montantVerse: lstPaie.reduce((acc, curr) => Number(acc) + Number(curr.montantPayement),0),
              icon:snap.val().icon,
              solde:snap.val().solde,
              type:snap.val().type,
              montant_due:snap.val().montant_due,
              datePaie0: snap.val().dateInsert0,
              datePaie:this.sharedService.ConvertDMYorYMD(snap.val().date_paiement),
              partage:snap.val().idkeyPar,
              idproprio:snap.val().idKey,
              namePar:snap.val().namePar
            })     
          } catch (error) {
            
          }
             
      })
    });

  return await this.PrepareData(handelResult,"oui")

  }





    
  private Etatpuce(doc:string): string[]{
    const puce=[]
    if (doc=="encours") {
       puce[0]="../../../assets/img/d_encours.png"
       puce[1]="En cours"
    } else if(doc=="Prêt") {
       puce[0]="../../../assets/img/d_pret.png"
       puce[1]="Prêt"
    } else if (doc=="retire"){
       puce[0]="../../../assets/img/d_retire.png"
       puce[1]="Retiré"
    }
  return puce;
  }


  private PrepareData(data: any[],partage:string=""): any[] {

    return this.TriPolice(data,partage)

  }
  
  private TriPolice(data:any[],partage:string="")  {
    const result0 = [];
    const map = new Map();
    for (const item of data) {
      // if (!map.has(item.NumPolice)) {
      //   map.set(item.NumPolice, true);   
       result0.push(item);
      // }
    }
   // this.result = result0;
  
   result0.sort((a,b) => (a.datePaie0<b.datePaie0)?  1:-1)
   //console.log(result0);
   if (partage=="oui") {
    this.Lesquittances0.next(result0)
   }else{
    this.Lesquittances.next(result0)
   }

    return result0;
  }
 
}
